<div class="row">
    <div class="col-6 pr-2">
        <label for="">Data inicio</label>
        <input [ngModel]="formatInicio" (ngModelChange)="setInicio($event, dinicio)" (focus)="dinicio.open()" [maxDate]="formatFim" name="dataInicio"  ngbDatepicker #dinicio="ngbDatepicker" type="text"
          class="form-control">
      </div>
      <div class="col-6 pl-2">
        <label for="">Data termino</label>
        <input [ngModel]="formatFim" (ngModelChange)="setFim($event, dfim);"  (focus)="dfim.open()" [minDate]="formatInicio" name="dataFim"  ngbDatepicker #dfim="ngbDatepicker" type="text" class="form-control">
      </div>
</div>